//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { Enums } from '../common/enums'

import { DataProvider } from '../../helpers/data-provider'
import { TypeHelper } from '../../helpers/type-helper'

import { OpDescr } from './op-descr'

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'

export class OpDataTypeClass implements IReferenceType, IOpChangeState, IJsonSerializable {
    public idDataTypeClass: number
    public name: string
    public idDescr: number
    public descr: OpDescr

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdDataTypeClass
    }
    public getReferenceKey(): number {
        return this.idDataTypeClass
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || opObj.__IC === 1) {
                this.idDataTypeClass = opObj.I
                this.idDescr = opObj.ID
                this.name = opObj.N

                this.descr = opObj.D ? new OpDescr(opObj.D) : null

                this.opState = opObj.O
            }
            else {
                this.idDataTypeClass = opObj.ID_DATA_TYPE_CLASS
                this.idDescr = opObj.ID_DESCR

                this.name = opObj.NAME

                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null

                this.opState = opObj.OpState
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const compressedObj: any = {
                I: this.idDataTypeClass,
                ID: this.idDescr,
                N: this.name,

                D: this.descr != null ? this.descr.toJSON(compressed) : null,

                O: this.opState,

                __IC: 1
            }

            TypeHelper.deleteNulls(compressedObj)

            return compressedObj
        }
        else {
            return {
                ID_DATA_TYPE_CLASS: this.idDataTypeClass,
                ID_DESCR: this.idDescr,

                NAME: this.name,

                _Descr: this.descr != null ? this.descr.toJSON() : null,

                OpState: this.opState
            }
        }
        
    }

    public toString() {
        if (this.descr)
            return this.descr.description
        else
            return this.name
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpDataTypeClass[]): JQueryPromise<OpDataTypeClass[]> {
        var defered = $.Deferred<OpDataTypeClass[]>()

        defered.resolve(list)

        return defered.promise()
    }

    public static restore(restoredOpObj: OpDataTypeClass) {
        if (restoredOpObj) {
            var opObj = new OpDataTypeClass()
            opObj.idDataTypeClass = restoredOpObj.idDataTypeClass
            opObj.name = restoredOpObj.name
            opObj.idDescr = restoredOpObj.idDescr
            opObj.descr = OpDescr.restore(restoredOpObj.descr)
            opObj.opState = restoredOpObj.opState
            return opObj
        }
        return null
    }
}